<template>
  <nav
    class="pagination"
    role="navigation"
    aria-label="pagination"
    v-bind="$attrs">

    <ul class="pagination-list">

      <!-- first page -->
      <li>
        <a
          class="pagination-link"
          :class="{'is-current': value == 1 }"
          aria-label="Goto page 1"
          @click="changePage(1)">
          1
        </a>
      </li>

      <template v-if="length > 2">
        <li
          v-for="(page, index) in visiblePages"
          :key="index">
          <a
            class="pagination-link"
            :class="{
              'is-current': page == value,
              'disabled': condensed.includes(index + 1)
            }"
            :aria-label="`Goto page ${page}`"
            @click="changePage(page)"
            v-if="!condensed.includes(index + 1) || condensed.length == 0">
            {{ page }}
          </a>
          <span class="pagination-ellipsis" v-else>
            &hellip;
          </span>
        </li>
      </template>

      <!-- last page -->
      <li v-if="length > 1">
        <a
          class="pagination-link"
          :class="{'is-current': value == length}"
          :aria-label="`Goto page ${length}`"
          @click="changePage(length)">
          {{ length }}
        </a>
      </li>

    </ul>

    <button
      class="button pagination-previous"
      :disabled="value == 1"
      @click="changePage(value - 1)">
      Previous page
    </button>

    <button
      class="button pagination-next"
      :disabled="value == length"
      @click="changePage(value + 1)">
      Next page
    </button>

  </nav>
</template>

<script>
export default {
  name: 'pagination',
  data() {
    return {
      visibleLength: 7
    }
  },
  props: {
    value: Number,
    length: {
      default: 2,
      type: Number
    }
  },
  computed: {
    visiblePages({ value, length, visibleLength }) {
      let list = [];
      if (length <= visibleLength) {
        let i = 2;
        for (i; i < length; i++) {
          list.push(i)
        }
      } else if (length > visibleLength) {
        if (value <= visibleLength / 2 - 1) {
          let i = 2;
          for (i; i < visibleLength / 2; i++) {
            list.push(i);
          }
          for (i = length - (visibleLength - 1) / 2; i < length; i++) {
            list.push(i);
          }
        } else if (value > visibleLength / 2 - 1 &&
                  value < visibleLength - 2) {
          let i = 2;
          for (i; i <= visibleLength - 1; i++) {
            list.push(i);
          }
        } else if (value >= visibleLength - 2 &&
                  value < length - (visibleLength - 3) /2) {
          let numPad = (visibleLength - 3) / 2;
          let i = value - numPad;
          for (i; i <= (value + numPad); i++) {
            list.push(i);
          }
        } else {
          let i = length - (visibleLength - 2);
          for (i; i < length; i++) {
            list.push(i);
          }
        }
      }
      return list;
    },
    condensed({ value, visibleLength, length }) {
      if (length <= visibleLength) {
        return []
      } else {
        if (value <= visibleLength / 2 - 1) {
          return [(visibleLength - 1) / 2]
        } else if (value > visibleLength / 2 - 1 &&
                  value < visibleLength - 2){
          return [visibleLength - 2]
        } else if (value >= visibleLength - 2 &&
                  value < length - (visibleLength - 1) /2) {
          return [1, visibleLength - 2]
        } else if (value >= length - (visibleLength - 1) /2) {
          return [1]
        } else {
          return null
        }
      }
    }
  },
  methods: {
    changePage(value) {
      if (value <= this.length && value > 0) {
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
